import { HOME_PAGE_ROUTES } from "@/data";
import { useHomePage } from "@/hooks";
import { Props } from "@/models";
import { motion } from "framer-motion";
import { FC, memo } from "react";
import { NavLink, useLocation } from "react-router-dom";

export const MenuNav = ({
  to,
  title,
  Icon,
  isRed,
  activeClassName,
  inactiveClassName,
  comingSoon,
}: Props.MenuNav) => {
  const { clearHomePageState } = useHomePage();
  const location = useLocation();

  const isActive =
    (location.pathname === HOME_PAGE_ROUTES.DATA &&
      to === HOME_PAGE_ROUTES.AIRTIME) ||
    ([
      HOME_PAGE_ROUTES.BETTING,
      HOME_PAGE_ROUTES.CABLE_TV,
      HOME_PAGE_ROUTES.EDUCATION,
      HOME_PAGE_ROUTES.ELECTRICITY,
    ].includes(location.pathname) &&
      to === HOME_PAGE_ROUTES.BILL_PAYMENTS) ||
    location.pathname === to;

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      transition={{ duration: 0.4, ease: "easeInOut" }}
      whileTap={{ scale: 0.7 }}
      className="w-full"
    >
      <NavLink
        to={to}
        className={`relative rounded-2xl flex items-center h-12 justify-start px-5 gap-2 overflow-hidden  ${
          isActive ? `${activeClassName}` : `${inactiveClassName}`
        }`}
        onClick={clearHomePageState}
      >
        {
          <>
            {Icon && (
              <Icon
                size="20"
                color={isActive ? (isRed ? "#FF6D00" : "#006F01") : "#FFFFFF"}
              />
            )}
            <span className="text-sm font-semibold">{title}</span>
            {comingSoon && (
              <span className="ml-2 text-[10px] absolute bottom-0 right-0 px-2 pr-3  bg-red-400 text-white rounded-tl-sm">
                Coming Soon
              </span>
            )}
          </>
        }
      </NavLink>
    </motion.div>
  );
};

const Mobile: FC<Props.MenuNav> = ({ to, title, Icon }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      transition={{ duration: 0.4, ease: "easeInOut" }}
      whileTap={{ scale: 0.7 }}
      className=""
    >
      <NavLink
        to={to}
        className={({ isActive }) => {
          return `rounded-2xl flex flex-col gap-2 items-center h-14 ${
            isActive ? "" : ""
          }`;
        }}
      >
        {({ isActive }) => (
          <>
            {Icon && (
              <Icon size="20" color={isActive ? "#006F01" : "#000000"} />
            )}
            <span
              className={`text-sm lg:text-base font-semibold ${
                isActive && "text-green-600"
              }`}
            >
              {title}
            </span>
          </>
        )}
      </NavLink>
    </motion.div>
  );
};

MenuNav.Mobile = memo(Mobile);
